import { Action } from 'redux';
import * as _ from 'underscore';

import { ExplorableItemType } from '../../../ts/models/ContentType';
import { IDataSourceInfo } from '../../../ts/models/IDataSourceInfo';
import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { DataSources } from '../../../ts/resources/Datasources';
import { ContentFavoriteAdded } from '../../actions/AppActionTypes';
import { isContentFavoriteAddedAction, isContentFavoriteRemovedAction, isRemoveFavoritedItemAction } from '../../actions/spaces/FavoritesActions';
import { isUpdateContentDetailAction } from '../../actions/spaces/GetContentDetailAction';
import {
  isSpaceContentsRequestFailedAction,
  isSpaceContentsRequestSucceededAction,
  isSpaceContentsSliceSucceededAction
} from '../../actions/spaces/RequestSpaceContentsActions';

function findIndexOfContent(content: ReadonlyArray<IExplorableItemTypeInfo>, type: string, id: string): number {
  return _.findIndex(content, c => c && c.contentType === type && c.id === id);
}

function updateContent(content: ReadonlyArray<IExplorableItemTypeInfo>,
                       type: ExplorableItemType,
                       id: string,
                       updateOptions: any
): ReadonlyArray<IExplorableItemTypeInfo> {
  const index = findIndexOfContent(content, type, id);
  if (index > -1) {
    const newContent = content.slice(0);
    newContent[index] = {
      ...content[index],
      ...updateOptions
    };
    return newContent;
  }
  return content;
}

function removeContentItem(
  content: ReadonlyArray<IExplorableItemTypeInfo>,
  type: ExplorableItemType,
  id: string
): ReadonlyArray<IExplorableItemTypeInfo> {
  const index = findIndexOfContent(content, type, id);
  if (index > -1) {
    const newContent = content.slice();
    newContent.splice(index, 1);
    return newContent;
  }
  return content;
}

export function contentReducer(
  previousState: ReadonlyArray<IExplorableItemTypeInfo> = [],
  action: Action = null
): ReadonlyArray<IExplorableItemTypeInfo> {

  if (isSpaceContentsRequestSucceededAction(action) && action.content) {

    // Don't set a new empty array as that will trigger renders.
    if (action.content.items.length === 0 && previousState.length === 0) {
      return previousState;
    }

    // We ignore any items in previous state and begin anew
    // We assume the slice starts with zero index so just extend
    // items array to match the total
    const emptyMissingItems =
      new Array(action.content.total - action.content.items.length);
    return action.content.items.concat(emptyMissingItems);

  } else if (isSpaceContentsSliceSucceededAction(action) && action.content) {
    if (previousState.length === action.content.total) {
      // if total items hasn't changed insert  newly retrieved items
      // into our existing items
      const items = previousState.slice();
      items.splice(action.start, action.content.items.length, ...action.content.items);
      return items;
    } else {
      // Total number of items doesn't match our state total
      // So we start over and insert our slice
      const items = new Array(action.content.total);
      items.splice(action.start, action.content.items.length, ...action.content.items);
      return items;
    }

  } else if (isContentFavoriteAddedAction(action) || isContentFavoriteRemovedAction(action)) {
    let contentId = action.contentId;
    //ugh.. if the current content is unifieddatasources, the id needs to be remaped from datasource to connection id
    if(previousState.length > 0 && DataSources.isUnifiedDatasource(previousState[0])){
      let content = _.find(previousState,
            c => c.contentType === action.contentType && (c as IDataSourceInfo).idForFavoriting === action.contentId);
      if(content){
        contentId = content.id;
      }
    }
    return updateContent(previousState, action.contentType, contentId, {
      favorite: action.type === ContentFavoriteAdded
    });

  } else if (isUpdateContentDetailAction(action)) {
    let updatedContent = previousState;
    for(let content of action.content) {
      updatedContent = updateContent(updatedContent, content.contentType, content.id, {...content});
    }
    return updatedContent;

  } else if (isSpaceContentsRequestFailedAction(action)) {
    // Don't set a new empty array as that will trigger renders.
    if (previousState.length === 0) {
      return previousState;
    }

    return [];
  }

  return previousState;
}
